import Vue from "vue";
import VueRouter from "vue-router";

//-----------User Management Components--------------------
import Login from "../views/Login.vue";
import Peel_Hunt_Container from "../views/Peel_Hunt_Container.vue";
import Dashboard from "../views/Dashboard.vue";
import Logout from "../components/UserManagement/logout.vue";
import Resetpassword from "../views/ResetPassword.vue";
import UserRegistration from "../components/UserManagement/userRegistration.vue";
import UserSettings from "../components/UserManagement/userSettings.vue";
import UserManagement from "../components/UserManagement/settings/adminSettings.vue";
import ChangePassword from "../components/UserManagement/changePassword.vue";
import CustomizeAccess from "@/components/UserManagement/customizeaccess/customizeAccess.vue";
//--------------Dashboard Components-----------------------
//Valuation
import Valuation from "../components/Valuation/index.vue";
import Sector_valuation from "../components/Valuation/Sector_Valuations.vue";
import Iframe_Component_Wrapper from "../components/Iframe_wrapper/Iframe_Component_Wrapper.vue";
import Profitability from "../components/Valuation/Profitability.vue";
import Leverage from "../components/Valuation/Leverage.vue";
import Technical from "../components/Valuation/Technical.vue";
import End_Market_Exposure from "../components/Valuation/End_Market_Exposure.vue";
import Price_Performance from "../components/Valuation/Price_Performance.vue";
import Stock_Correlation from "../components/Valuation/Stock_Correlation.vue";
import Mcap from "../components/Valuation/Mcap.vue";
import Revenue_Composition from "../components/Valuation/Revenue_Composition.vue";

//Sector/Industry Insights
import Sector_Industry_Insights from "../components/Sector/index.vue";
import Methanol from "../components/Sector/Methanol.vue";
import Cost_Curve from "../components/Sector/Cost_Curve.vue";
import Ethanol_RBOB from "../components/Sector/Ethanol_RBOB.vue";
import Production from "../components/Sector/Production.vue";
import Reinvestment from "../components/Sector/Reinvestment.vue";
import Utilization from "../components/Sector/Utilization.vue";
import Global_Utilization from "../components/Sector/Global_Utilization.vue";
import Pricing from "../components/Sector/Pricing.vue";

//Macro Economic Indicators
import Macro_Economic_Indicators from "../components/Macro/index.vue";
import RecessionRisks from "../components/Macro/recessionriskstilllimitednearterm/RecessionRisks.vue";
import Probability_Based_On_CFNAI from "../components/Macro/recessionriskstilllimitednearterm/Probability_Based_On_CFNAI.vue";
import Probability_Based_On_Yield_Curve from "../components/Macro/recessionriskstilllimitednearterm/Probability_Based_On_Yield_Curve.vue";
import Recession_Criteria_Change_vs_End_Of_Last_Recession from "../components/Macro/recessionriskstilllimitednearterm/Recession_Criteria_Change_vs_End_Of_Last_Recession.vue";
import LeadingIndicators from "../components/Macro/leadingindicator/LeadingIndicators.vue";
import Ratio_Conincident_Lagging from "../components/Macro/recessionriskstilllimitednearterm/Ratio_Conincident_Lagging.vue";
import OECD_leading_indicators_Global_US_and_Europe from "../components/Macro/leadingindicator/OECD_leading_indicators_Global_US_and_Europe.vue";
import OECD_leading_indicators_China_Japan_Brazil from "../components/Macro/leadingindicator/OECD_leading_indicators_China_Japan_Brazil.vue";
import US_leading_indicator_3mo_6mo_12mo_change from "../components/Macro/leadingindicator/US_leading_indicator_3mo_6mo_12mo_change.vue";
import China_leading_indicator_3mo_6mo_12mo_change from "../components/Macro/leadingindicator/China_leading_indicator_3mo_6mo_12mo_change.vue";
import USIndustrialProduction from "../components/Macro/usindustrialproduction/USIndustrialProduction.vue";
import IP_Index_YoY from "../components/Macro/usindustrialproduction/IP_Index_YoY.vue";
import ISM_vs_WTI_Oil_YoY from "../components/Macro/usindustrialproduction/ISM_vs_WTI_Oil_YoY.vue";
import Traded_weighted from "../components/Macro/usindustrialproduction/Traded_weighted.vue";
import US_IP_CAGR from "../components/Macro/usindustrialproduction/US_IP_CAGR.vue";
import GDP from "../components/Macro/gdp/gdp.vue";
import EU_GDP_Forecast from "../components/Macro/gdp/EU_GDP_Forecast.vue";
import Belgian_Industrial_Confidence_vs_ECB_lendingEasing from "../components/Macro/gdp/Belgian_Industrial_Confidence_vs_ECB_lendingEasing.vue";
import ECB_Money_Supply from "../components/Macro/gdp/ECB_Money_Supply.vue";
import EU_Chemicals_IP_vs_EU_Industrial_Confidence from "../components/Macro/gdp/EU_Chemicals_IP_vs_EU_Industrial_Confidence.vue";
import Inventory from "../components/Macro/inventory/inventory.vue";
import Impact_Of_10_Swing_In_Consumer_Demand_On_Suppliers from "../components/Macro/inventory/ImpactOfSwingIncunsumerDemandonsuppliers.vue";
import ISM_Inventories_Survey from "../components/Macro/inventory/ISM_Inventories_Survey.vue";
import Final_sales_vs_inventories from "../components/Macro/inventory/Final_sales_vs_inventories.vue";
import Chemical_Sector_Pricing_Power from "../components/Macro/inventory/Chemical_Sector_Pricing_Power.vue";
import ConsumerSpending from "../components/Macro/consumerspending/ConsumerSpending.vue";
import PCE_Forecast from "../components/Macro/consumerspending/PCE_Forecast.vue";
import Real_GDP_Forecast from "../components/Macro/consumerspending/Real_GDP_Forecast.vue";
import Fed_Fund_Rate_Consumer_Spending from "../components/Macro/consumerspending/Fed_Fund_Rate_Consumer_Spending.vue";
import Durable_Investment from "../components/Macro/consumerspending/Durable_Investment.vue";
import USConstruction from "../components/Macro/usconstruction/USConstruction.vue";
import Residential_Nonresidential_construction from "../components/Macro/usconstruction/Residential_Nonresidential_construction.vue";
import New_Family_Homes from "../components/Macro/usconstruction/New_Family_Homes.vue";
import US_Construction_Spending from "../components/Macro/usconstruction/US_Construction_Spending.vue";
import NAHB_Leads_Final_Sales_Housing_Start from "../components/Macro/usconstruction/NAHB_Leads_Final_Sales_Housing_Start.vue";
import InflationHardertopace from "../components/Macro/inflationhardertopace/InflationHardertopace.vue";
import PPI_Intermediate_Goods from "../components/Macro/inflationhardertopace/PPI_Intermediate_Goods.vue";
import PPI_Finished_goods from "../components/Macro/inflationhardertopace/PPI_Finished_goods.vue";
import Govt_Outlays from "../components/Macro/inflationhardertopace/Govt_Outlays.vue";
import Inflation from "../components/Macro/inflation/Inflation.vue";
import US_CPI from "../components/Macro/inflation/US_CPI.vue";
import Brent_vs_Natural_Gas from "../components/Macro/inflation/Brent_vs_Natural_Gas.vue";
import CPI_vs_PPI from "../components/Macro/inflation/CPI_vs_PPI.vue";
import Chemical_sector_pricing from "../components/Macro/inflation/Chemical_sector_pricing.vue";
import Retail_Sales from "../components/Macro/retailsales/Retail_Sales.vue";
import Real_Retail_Sales from "../components/Macro/retailsales/Real_Retail_Sales.vue";
import Effective_Tax_Rate from "../components/Macro/retailsales/Effective_Tax_Rate.vue";
import CapitalSpending from "../components/Macro/capitalspending/CapitalSpending.vue";
import Capex_YoY from "../components/Macro/capitalspending/Capex_YoY.vue";
import Fed_Cap_Index from "../components/Macro/capitalspending/Fed_Cap_Index.vue";
import Capex_Cycle from "../components/Macro/capitalspending/Capex_Cycle.vue";
import Chemical_sector_capex from "../components/Macro/capitalspending/Chemical_sector_capex.vue";
import Corn from "../components/Macro/corn/Corn.vue";
import Corn_YoY from "../components/Macro/corn/Corn_YoY.vue";
import Corn_Profit_Margins from "../components/Macro/corn/Corn_Profit_Margins.vue";
import Corn_Yield from "../components/Macro/corn/Corn_Yield.vue";
import NetDebtEditda from "../components/Macro/netdebteditda/NetDebtEditda.vue";
import Rolling_Net_Debt_EBITDA from "../components/Macro/netdebteditda/Rolling_Net_Debt_EBITDA.vue";
import Deleveraging from "../components/Macro/netdebteditda/Deleveraging.vue";
import RegionalTrends from "../components/Macro/regionaltrends/RegionalTrends.vue";
import CPI_and_Sentiments from "../components/Macro/regionaltrends/CPI_and_Sentiments.vue";
import GDP_Treasury_yield from "../components/Macro/regionaltrends/GDP_Treasury_yield.vue";
import Risk_spread from "../components/Macro/regionaltrends/Risk_spread.vue";

//Stock Screens
import StockScreens from "../components/Stock/Stock.vue";
import Mean_Reversion from "../components/Stock/Mean_Reversion.vue";
import Peel_hunt_screen from "../components/Stock/Peel_Hunt_Screen.vue";
import Comp_Sheet_Large_Cap from "../components/Stock/Comp_Sheet_Large_Cap.vue";
import Comp_Sheet_Mid_Cap from "../components/Stock/Comp_Sheet_Mid_Cap.vue";

//Coverage Universe
import Coverage_Universe from "../components/Coverage/index.vue";
import Coverage_Universe_Tab from "../components/Coverage/Coverage_Universe_Tab.vue";
import Historical_Top_10 from "../components/Coverage/Historical_Top_10.vue";

//Waterfall
import Waterfall from "../components/Waterfall/index.vue";
import Sales from "../components/Waterfall/Sales.vue";
import Ebitda from "../components/Waterfall/EBITDA.vue";

//Sensitivity Table
import Sensitivity_Table from "../components/iMost/index.vue";
import Snapshot from "../components/iMost/Snapshot.vue";
import Revenue_Drivers from "../components/iMost/Revenue_Drivers.vue";
import Cost_Drivers from "../components/iMost/Cost_Drivers.vue";
import BS_Drivers from "../components/iMost/BS_Drivers.vue";
//------------------
import store from "../store";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next();
    return;
  } else {
    if (to.name != "Dashboard") {
      // console.log(to.name)
      next("/dashboard");
    }
  }
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next();
    return;
  } else {
    // console.log(to.name)
    if (to.name == "Login" || to.name == "logout") {
      next();
    } else {
      next("/login");
    }
  }
};

const routes = [
  /**
   * User Management
   * */
  {
    path: "/",
    name: "login",
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/:chart_component_name/auth_token=:token/",
    name: "Iframe_Component_Wrapper",
    component: Iframe_Component_Wrapper,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/stockScreener/sectors",
    name: "Peel_Hunt_Container",
    component: Peel_Hunt_Container,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/fs/peelHuntContER/",
    name: "Peel_Hunt_Container",
    component: Peel_Hunt_Container,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/fs/peelHuntCont",
    name: "Peel_Hunt_Container",
    component: Peel_Hunt_Container,
    beforeEnter: ifNotAuthenticated,
  },
  { path: "/login", redirect: "/" },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
  },
  {
    path: "/resetpassword/:token/",
    name: "resetPassword",
    component: Resetpassword,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/userRegistration",
    name: "UserRegistration",
    component: UserRegistration,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/userSettings",
    name: "UserSettings",
    component: UserSettings,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/userManagement",
    name: "UserManagement",
    component: UserManagement,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/changePassword",
    name: "ChangePassword",
    component: ChangePassword,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/customizeAccess/:userId/",
    name: "CustomizeAccess",
    component: CustomizeAccess,
    beforeEnter: ifAuthenticated,
  },
  /**
   * Dashboards
   * **/

  //------------Dashboards------------------
  //Valuation
  {
    path: "/Valuation",
    name: "Valuation",
    component: Valuation,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "sectorvaluations",
        name: "sector_valuations",
        component: Sector_valuation,
      },
      {
        path: "profitability",
        name: "Profitability",
        component: Profitability,
      },
      { path: "leverage", name: "Leverage", component: Leverage },
      { path: "technical", name: "Technical", component: Technical },
      {
        path: "endmarketexposure",
        name: "Endmarketexposure",
        component: End_Market_Exposure,
      },
      {
        path: "priceperformance",
        name: "PricePerformance",
        component: Price_Performance,
      },
      {
        path: "stockcorrelation",
        name: "StockCorrelation",
        component: Stock_Correlation,
      },
      { path: "mcap", name: "Mcap", component: Mcap },
      {
        path: "revenuecomposition",
        name: "RevenueComposition",
        component: Revenue_Composition,
      },
    ],
  },
  //Sector/Industry Insights
  {
    path: "/Sector_Industry_Insights",
    name: "Sector_Industry_Insights",
    component: Sector_Industry_Insights,
    beforeEnter: ifAuthenticated,

    children: [
      { path: "methanol", name: "methanol", component: Methanol },
      { path: "costcurve", name: "costcurve", component: Cost_Curve },
      { path: "ethanolrcb", name: "ethanolrcb", component: Ethanol_RBOB },
      { path: "production", name: "Production", component: Production },
      { path: "reinvestment", name: "reinvestment", component: Reinvestment },
      { path: "utilization", name: "utilization", component: Utilization },
      {
        path: "globalutilization",
        name: "globalutilization",
        component: Global_Utilization,
      },
      { path: "pricing", name: "pricing", component: Pricing },
    ],
  },
  //Macro Economic Indicators
  {
    path: "/Macro_Economic_Indicators",
    name: "Macro_Economic_Indicators",
    component: Macro_Economic_Indicators,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "recessionriskstilllimitednearterm",
        name: "recessionriskstilllimitednearterm",
        component: RecessionRisks,
        children: [
          {
            path: "probabilitybasedoncfnai",
            name: "probabilitybasedoncfnai",
            component: Probability_Based_On_CFNAI,
          },
          {
            path: "probabilitybasedonyieldcurve",
            name: "probabilitybasedonyieldcurve",
            component: Probability_Based_On_Yield_Curve,
          },
          {
            path: "recessioncriteriachangevsendoflastrecession",
            name: "recessioncriteriachangevsendoflastrecession",
            component: Recession_Criteria_Change_vs_End_Of_Last_Recession,
          },
          {
            path: "ratioconincidentlaggingleiyoyvsrecessiontiming",
            name: "ratioconincidentlaggingleiyoyvsrecessiontiming",
            component: Ratio_Conincident_Lagging,
          },
        ],
      },
      {
        path: "leadingindicator",
        name: "leadingindicator",
        component: LeadingIndicators,
        children: [
          {
            path: "oecdleadingindicatorschinajapanbrazil",
            name: "oecdleadingindicatorschinajapanbrazil",
            component: OECD_leading_indicators_China_Japan_Brazil,
          },
          {
            path: "oecdleadingindicatorsglobalusandeurope",
            name: "oecdleadingindicatorsglobalusandeurope",
            component: OECD_leading_indicators_Global_US_and_Europe,
          },
          {
            path: "recessioncreteria",
            name: "recessioncreteria",
            component: Recession_Criteria_Change_vs_End_Of_Last_Recession,
          },
          {
            path: "usleadingindicatormomomochange",
            name: "usleadingindicatormomomochange",
            component: US_leading_indicator_3mo_6mo_12mo_change,
          },
          {
            path: "chinaleadingindicatormomomochange",
            name: "chinaleadingindicatormomomochange",
            component: China_leading_indicator_3mo_6mo_12mo_change,
          },
        ],
      },
      {
        path: "usindustrialproduction",
        name: "usindustrialproduction",
        component: USIndustrialProduction,
        children: [
          { path: "ipindexyoy", name: "ipindexyoy", component: IP_Index_YoY },
          {
            path: "ismvswtioilyoy",
            name: "ismvswtioilyoy",
            component: ISM_vs_WTI_Oil_YoY,
          },
          {
            path: "tradedweighted",
            name: "tradedweighted",
            component: Traded_weighted,
          },
          { path: "usipcagr", name: "usipcagr", component: US_IP_CAGR },
        ],
      },
      {
        path: "gdp",
        name: "gdp",
        component: GDP,
        children: [
          {
            path: "eugdpforecast",
            name: "eugdpforecast",
            component: EU_GDP_Forecast,
          },
          {
            path: "belgianindustrialconfidencevsecblendingeasing",
            name: "belgianindustrialconfidencevsecblendingeasing",
            component: Belgian_Industrial_Confidence_vs_ECB_lendingEasing,
          },
          {
            path: "ecbmoneysupply",
            name: "ecbmoneysupply",
            component: ECB_Money_Supply,
          },
          {
            path: "euchemicalsipvseuindustrialconfidence",
            name: "euchemicalsipvseuindustrialconfidence",
            component: EU_Chemicals_IP_vs_EU_Industrial_Confidence,
          },
        ],
      },
      {
        path: "inventory",
        name: "inventory",
        component: Inventory,
        children: [
          {
            path: "isminventoriessurvey",
            name: "isminventoriessurvey",
            component: ISM_Inventories_Survey,
          },
          {
            path: "impactofswingincunsumerdemandonsuppliers",
            name: "impactofswingincunsumerdemandonsuppliers",
            component: Impact_Of_10_Swing_In_Consumer_Demand_On_Suppliers,
          },
          {
            path: "finalsalesvsinventories",
            name: "finalsalesvsinventories",
            component: Final_sales_vs_inventories,
          },
          {
            path: "chemicalsectorpricingpower",
            name: "chemicalsectorpricingpower",
            component: Chemical_Sector_Pricing_Power,
          },
        ],
      },
      {
        path: "retailsales",
        name: "retailsales",
        component: Retail_Sales,
        children: [
          {
            path: "realretailsales",
            component: Real_Retail_Sales,
          },
          {
            path: "effectivetaxrate",
            component: Effective_Tax_Rate,
          }
        ],
      },
      {
        path: "consumerspending",
        name: "consumerspending",
        component: ConsumerSpending,
        children: [
          { path: "pceforecast", name: "pceforecast", component: PCE_Forecast },
          {
            path: "realgdpforecast",
            name: "realgdpforecast",
            component: Real_GDP_Forecast,
          },
          {
            path: "fedfundrateconsumerspending",
            name: "fedfundrateconsumerspending",
            component: Fed_Fund_Rate_Consumer_Spending,
          },
          {
            path: "durableinvestment",
            name: "durableinvestment",
            component: Durable_Investment,
          },
        ],
      },
      {
        path: "usconstruction",
        name: "usconstruction",
        component: USConstruction,
        children: [
          {
            path: "residentialnonresidentialconstruction",
            name: "residentialnonresidentialconstruction",
            component: Residential_Nonresidential_construction,
          },
          {
            path: "newfamilyhomes",
            name: "newfamilyhomes",
            component: New_Family_Homes,
          },
          {
            path: "usconstructionspending",
            name: "usconstructionspending",
            component: US_Construction_Spending,
          },
          {
            path: "nahbleadsfinalsaleshousingstart",
            name: "nahbleadsfinalsaleshousingstart",
            component: NAHB_Leads_Final_Sales_Housing_Start,
          },
        ],
      },
      {
        path: "inflationhardertopace",
        name: "inflationhardertopace",
        component: InflationHardertopace,
        children: [
          {
            path: "ppiintermediategoods",
            name: "ppiintermediategoods",
            component: PPI_Intermediate_Goods,
          },
          {
            path: "ppifinishedgoods",
            name: "ppifinishedgoods",
            component: PPI_Finished_goods,
          },
          { path: "govtoutlays", name: "govtoutlays", component: Govt_Outlays },
        ],
      },
      {
        path: "inflation",
        name: "inflation",
        component: Inflation,
        children: [
          { path: "uscpi", name: "uscpi", component: US_CPI },
          {
            path: "brentvsnaturalgas",
            name: "brentvsnaturalgas",
            component: Brent_vs_Natural_Gas,
          },
          { path: "cpivsppi", name: "cpivsppi", component: CPI_vs_PPI },
          {
            path: "chemicalsectorpricing",
            name: "chemicalsectorpricing",
            component: Chemical_sector_pricing,
          },
        ],
      },
      {
        path: "capitalspending",
        name: "capitalspending",
        component: CapitalSpending,
        children: [
          { path: "uscpi", name: "uscpi", component: US_CPI },
          {
            path: "brentvsnaturalgas",
            name: "brentvsnaturalgas",
            component: Brent_vs_Natural_Gas,
          },
          { path: "cpivsppi", name: "cpivsppi", component: CPI_vs_PPI },
          {
            path: "chemicalsectorpricing",
            name: "chemicalsectorpricing",
            component: Chemical_sector_pricing,
          },
        ],
      },
      {
        path: "capitalspending",
        name: "capitalspending",
        component: CapitalSpending,
        children: [
          { path: "capexyoy", name: "capexyoy", component: Capex_YoY },
          {
            path: "fedcapindex",
            name: "fedcapindex",
            component: Fed_Cap_Index,
          },
          { path: "capexcycle", name: "capexcycle", component: Capex_Cycle },
          {
            path: "chemicalsectorcapex",
            name: "chemicalsectorcapex",
            component: Chemical_sector_capex,
          },
        ],
      },
      {
        path: "corn",
        name: "corn",
        component: Corn,
        children: [
          { path: "cornyoy", name: "cornyoy", component: Corn_YoY },
          {
            path: "cornprofitmargins",
            name: "cornprofitmargins",
            component: Corn_Profit_Margins,
          },
          { path: "cornyield", name: "cornyield", component: Corn_Yield },
        ],
      },
      {
        path: "netdebteditda",
        name: "netdebteditda",
        component: NetDebtEditda,
        children: [
          {
            path: "rollingnetdebtebitda",
            name: "rollingnetdebtebitda",
            component: Rolling_Net_Debt_EBITDA,
          },
          {
            path: "deleveraging",
            name: "deleveraging",
            component: Deleveraging,
          },
        ],
      },
      {
        path: "regionaltrends",
        name: "regionaltrends",
        component: RegionalTrends,
        children: [
          {
            path: "cpiandsentiments",
            name: "cpiandsentiments",
            component: CPI_and_Sentiments,
          },
          {
            path: "gdptreauryyield",
            name: "gdptreauryyield",
            component: GDP_Treasury_yield,
          },
          { path: "riskspread", name: "riskspread", component: Risk_spread },
        ],
      },
    ],
  },

  //Stock Screens
  {
    path: "/Stock_Screens",
    name: "Stock_Screens",
    component: StockScreens,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "meanreversion",
        name: "meanreversion",
        component: Mean_Reversion,
      },
      {
        path: "compsheetlargecap",
        name: "compsheetlargecap",
        component: Comp_Sheet_Large_Cap,
      },
      {
        path: "compsheetmidcap",
        name: "compsheetmidcap",
        component: Comp_Sheet_Mid_Cap,
      },
      {
        path: "peelhunt",
        name: "peel_hunt_screen",
        component: Peel_hunt_screen,
      },
    ],
  },
  //Coverage Universe
  {
    path: "/Coverage_Universe",
    name: "Coverage_Universe",
    component: Coverage_Universe,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "historicaltop10",
        name: "historicaltop10",
        component: Historical_Top_10,
      },
      {
        path: "coverageuniversetab",
        name: "coverageuniverse",
        component: Coverage_Universe_Tab,
      },
    ],
  },
  //Waterfall
  {
    path: "/Waterfall",
    name: "Waterfall",
    component: Waterfall,
    beforeEnter: ifAuthenticated,
    children: [
      { path: "sales", name: "sales", component: Sales },
      { path: "ebitda", name: "ebitda", component: Ebitda },
    ],
  },
  //Sensitivity Table
  {
    path: "/Sensitivity_Table",
    name: "Sensitivity_Table",
    component: Sensitivity_Table,
    beforeEnter: ifAuthenticated,
    children: [
      { path: "snapshot", name: "snapshot", component: Snapshot },
      {
        path: "revenuedrivers",
        name: "revenuedrivers",
        component: Revenue_Drivers,
      },
      { path: "costdrivers", name: "costdrivers", component: Cost_Drivers },
      { path: "bsdrivers", name: "bsdrivers", component: BS_Drivers },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
